import { useEffect, useState } from 'react';

/**
 * The current time, refreshed every `intervalMs` while `enabled`.
 *
 * 2026-10-07: live durations read this hook where they are shown, instead of
 * a clock in DialerContext: that clock changed the context value every
 * second and re-rendered the whole dialer (37 consumers, the 100-row
 * contacts table) for the sake of a few duration labels.
 */
export function useNow(intervalMs = 1000, enabled = true): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) return undefined;
    setNow(Date.now());
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs, enabled]);
  return now;
}
